import * as React from 'react';
import { useState } from 'react';
import ProductCard from '../Product/ProductCard';
import Favourites from '../../libraries/Favourites';
import { MoneyFormat } from '../Product/Price';

interface FavouriteListProps {
    moneyFormat: MoneyFormat,
    favouritesEmptyHTML: string
}
const FavouritesList = (props: FavouriteListProps) => {
    const { moneyFormat, favouritesEmptyHTML } = props;
    Favourites.init();
    const [allFavourites, setAllFavourites] = useState(Favourites.getAll());    
    window.addEventListener('favourites-change', function(data: CustomEventInit) {
        if (data.detail) {
            setAllFavourites(Favourites.getAll());
        }
    } as EventListener);
    if (allFavourites.length > 0) {
        return (
            <div className="favourites-list">
                { allFavourites.slice(0,24).map( (handle:string) => {
                    return <ProductCard key={ handle } productHandle={ handle } moneyFormat={ moneyFormat } />                                
                })}
            </div>
        )
    } else {
        return (
            <div className="favourites-empty" dangerouslySetInnerHTML={{__html: favouritesEmptyHTML }}></div>
        )
    }
}
export default FavouritesList;
